import React, {ReactNode} from "react";
import PuiTypography from "../../../../components/elements/PuiTypography";
import styles from "./FacetGroup.module.css";
import useResponsive from "../../../../common/useResponsive";

interface FacetGroupProps {
    title: string;
    children: ReactNode;
}

export default function FacetGroup({children, title}: FacetGroupProps) {
    const { isMobile } = useResponsive();
    return (
        <div className={styles.group}>
            <div className={styles.title}>
                <PuiTypography size={isMobile ? 16 : 20} bold={true}>{title}</PuiTypography>
            </div>

            <div className={styles.facets}>
                {children}
            </div>
        </div>
    );
}
